var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var UP_BUTTONS = [
    'ArrowUp',
    38
];
export var DOWN_BUTTONS = [
    'ArrowDown',
    40
];
export var LEFT_BUTTONS = [
    'ArrowLeft',
    37
];
export var RIGHT_BUTTONS = [
    'ArrowRight',
    39
];
export var SPACE_BUTTONS = [
    'Space',
    ' ',
    32
];
export var ESC_BUTTONS = [
    'Escape',
    'Esc',
    27
];
export var ENTER_BUTTONS = [
    'Enter',
    'NumpadEnter',
    13
];
export var DIRECTION_BUTTONS = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], UP_BUTTONS, true), DOWN_BUTTONS, true), LEFT_BUTTONS, true), RIGHT_BUTTONS, true);
